module.exports = __webpack_public_path__ + "img/preview.ed1cc378.webp";